import Input from '@/components/Input/Input';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography';
import type { WorkLocationValue } from '@/features/section-attribute/types';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
import { MasterDataCombobox } from './MasterDataCombobox';
type Props = CFormItemProps & {
  value: WorkLocationValue;
  onChange: (value: WorkLocationValue) => void;
  allowEmpty?: boolean;
};
export const CFormWorkLocationItem = buildCFormItem((props: Props) => {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'features.cForm.workLocationItem'
  });
  const value = props.value;
  const readComponent = <VStack className="gap-1">
      <Text variant="labelLarge">{value.name || '-'}</Text>
      {value.details && <Text variant="pSmall" className="text-neutral-muted-on-fill">
          {value.details}
        </Text>}
    </VStack>;
  const writeComponent = <VStack className="gap-2">
      <MasterDataCombobox value={value.workLocationId || undefined} displayValue={value.name || undefined} onChange={(id, label) => props.onChange({
      ...value,
      workLocationId: id || '',
      name: label || ''
    })} apiPath="/v2/places" queryKeyPrefix="workLocations" disabled={props.readonly} />
      <VStack className="gap-1">
        <Text variant="labelSmallReg" className="text-neutral-muted-on-fill">
          {t('details')}
        </Text>
        <Input width="100%" value={value.details ?? ''} onChange={e => props.onChange({
        ...value,
        details: e.target.value
      })} disabled={props.readonly} aria-label={t('details')} />
      </VStack>
    </VStack>;
  return <CFormItemBase {...props} readComponent={readComponent} writeComponent={writeComponent} />;
});